import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Entertainment%20news%20headlines%20on%20digital%20screen%2C%20warm%20studio%20lighting%2C%20modern%20media%20environment%2C%20soft%20coral%20pink%20color%20palette%2C%20editorial%20style%2C%20clean%20aesthetic%2C%20abstract%20geometric%20background%20with%20warm%20tones&width=600&height=800&seq=cat-grid-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20studio%20with%20ring%20light%2C%20modern%20content%20creation%20setup%2C%20warm%20sage%20green%20color%20palette%2C%20editorial%20photography%2C%20minimalist%20aesthetic%2C%20soft%20natural%20lighting%2C%20clean%20composition&width=600&height=800&seq=cat-grid-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20empty%20stage%2C%20theater%20atmosphere%2C%20warm%20neutral%20grey%20tones%2C%20editorial%20style%2C%20soft%20shadows%2C%20minimalist%20stage%20design%2C%20professional%20lighting%20setup&width=600&height=800&seq=cat-grid-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Trophy%20and%20award%20display%20with%20warm%20golden%20lighting%2C%20competition%20concept%2C%20elegant%20warm%20amber%20color%20palette%2C%20editorial%20style%2C%20soft%20shadows%2C%20luxurious%20atmosphere%2C%20clean%20display%20setting&width=600&height=800&seq=cat-grid-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Television%20production%20studio%20with%20colorful%20set%20design%2C%20broadcast%20environment%2C%20warm%20lighting%2C%20entertainment%20industry%2C%20editorial%20photography%2C%20professional%20camera%20equipment%2C%20creative%20workspace&width=600&height=800&seq=cat-grid-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20with%20mysterious%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20cinematic%20mood%2C%20editorial%20style%2C%20professional%20movie%20set%2C%20soft%20shadows%2C%20artistic%20composition&width=600&height=800&seq=cat-grid-06&orientation=landscape',
];

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider font-label">
            热门分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
            吃瓜不迷路
            <span className="font-heading italic font-normal text-accent-500 ml-2">分类导航</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block relative rounded-2xl overflow-hidden aspect-[3/4]"
            >
              <img
                src={categoryImages[index]}
                alt={cat.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm mb-2">
                  <i className={`${cat.icon} text-white text-sm`}></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-white">{cat.name}</h3>
                <p className="text-xs text-white/60 mt-1 line-clamp-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}